import { createGlobalStyle } from 'styled-components';

import Avenir from './Avenir_book.ttf';
import AvenirMedium from './AvenirLTPro-Medium.ttf';
import Macondo from './Macondo-Regular.ttf';

export default createGlobalStyle`
    @font-face {
        font-family: 'AvenirBook';
        src: local('AvenirBook'),
        url(${Avenir}) format('truetype');
    }

    @font-face {
        font-family: 'AvenirMedium';
        src: local('AvenirMedium'),
        url(${AvenirMedium}) format('truetype');
    }

    @font-face {
        font-family: 'Macondo';
        src: local('Macondo'),
        url(${Macondo}) format('truetype');
    }
`;